var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-upload',{ref:_vm.randomRef,attrs:{"show-file-list":false,"limit":1,"action":"#","http-request":_vm.uploadFile}},[_vm._t("inner")],2)}
var staticRenderFns = []

export { render, staticRenderFns }